import React from 'react';
import { Send } from 'lucide-react';
import { Modal } from '../ui/Modal';
import { Field, Input } from '../ui/Field';
import { toCurrency } from './invoiceTypes';

/**
 * L'envoi de la facture par email (maquette 8c, type « sélecteur d'envoi »).
 *
 * Migrée du `fixed inset-0` maison vers le socle de modale. Le sous-titre nomme ce qui part —
 * numéro et montant — pour qu'on relise avant d'envoyer, et le bouton porte le verbe plutôt qu'un
 * « Envoyer » seul qui ne dit pas quoi.
 */
export const InvoiceSendModal = ({
    open,
    invoiceNumber,
    totalTtc,
    email,
    onEmailChange,
    sending,
    onClose,
    onSend,
}: {
    open: boolean;
    invoiceNumber: string;
    totalTtc: number;
    email: string;
    onEmailChange: (v: string) => void;
    sending: boolean;
    onClose: () => void;
    onSend: () => void;
}) => (
    <Modal
        open={open}
        onClose={onClose}
        size="md"
        title="Envoyer la facture"
        subtitle={`${invoiceNumber || 'Facture sans numéro'} · ${toCurrency(totalTtc)} TTC`}
        footer={(
            <div className="flex justify-end gap-2.5">
                <button
                    type="button"
                    onClick={onClose}
                    className="h-9 px-4 inline-flex items-center rounded-full border border-border bg-surface text-[13px] font-semibold text-content hover:bg-surface-soft whitespace-nowrap shrink-0 transition-colors"
                >
                    Annuler
                </button>
                <button
                    type="button"
                    onClick={onSend}
                    disabled={sending}
                    className="h-9 px-4 inline-flex items-center gap-1.5 rounded-full bg-ink text-white text-[13px] font-semibold transition-opacity hover:opacity-90 disabled:opacity-60 whitespace-nowrap shrink-0"
                >
                    <Send size={14} /> {sending ? 'Envoi en cours…' : 'Envoyer la facture'}
                </button>
            </div>
        )}
    >
        <Field
            label="Email du destinataire"
            help="Prérempli depuis la fiche CRM. L'objet et le message viennent de vos modèles d'email."
        >
            {({ id, describedBy }) => (
                <Input
                    id={id}
                    aria-describedby={describedBy}
                    type="email"
                    value={email}
                    onChange={(e) => onEmailChange(e.target.value)}
                    placeholder="client@exemple.com"
                    autoFocus
                />
            )}
        </Field>
        <p className="mt-3 text-[12px] text-content-muted">
            La facture est enregistrée dans l’historique puis envoyée en PDF.
        </p>
    </Modal>
);
